import React from 'react';
import { Box, Typography } from '@mui/material';
import StorefrontIcon from '@mui/icons-material/Storefront';
import { useTranslation } from 'react-i18next';
import { findPackingChannel } from './packingModes';
import { useChannelLabel } from '../picking/useChannelLabel';

interface PackingChannelBannerProps {
  source?: string;
  // Kompakt (chip benzeri) mi yoksa dev banner mi.
  variant?: 'banner' | 'chip';
}

// Paketlemede hangi kanalin (Hepsiburada/Trendyol/Tacreo) kutusunun kullanilacagini
// net gostermek icin buyuk logo + renk seridi. Kanal cozulemezse hicbir sey render etmez.
const PackingChannelBanner: React.FC<PackingChannelBannerProps> = ({ source, variant = 'banner' }) => {
  const { t } = useTranslation('warehouse');
  const { resolveLabel } = useChannelLabel();
  const channel = findPackingChannel(source);
  if (!channel) return null;
  const label = resolveLabel(channel);

  if (variant === 'chip') {
    return (
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.75,
          px: 1,
          py: 0.5,
          borderRadius: 1.5,
          bgcolor: `${channel.color}14`,
          border: '1px solid',
          borderColor: `${channel.color}55`,
        }}
      >
        {channel.logo ? (
          <Box component="img" src={channel.logo} alt={label} sx={{ height: 18, objectFit: 'contain' }} />
        ) : (
          <StorefrontIcon sx={{ fontSize: 18, color: channel.color }} />
        )}
        <Typography variant="caption" sx={{ fontWeight: 700, color: channel.color }}>{label}</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        p: { xs: 1.5, sm: 2 },
        borderRadius: 3,
        bgcolor: `${channel.color}12`,
        border: '2px solid',
        borderColor: channel.color,
      }}
    >
      {channel.logo ? (
        <Box
          component="img"
          src={channel.logo}
          alt={label}
          sx={{ height: { xs: 40, sm: 52 }, maxWidth: 160, objectFit: 'contain', flexShrink: 0 }}
        />
      ) : (
        <StorefrontIcon sx={{ fontSize: { xs: 40, sm: 52 }, color: channel.color, flexShrink: 0 }} />
      )}
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ fontWeight: 800, fontSize: { xs: '1.3rem', sm: '1.6rem' }, lineHeight: 1.1, color: channel.color }}>
          {label}
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 700, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.03em' }}>
          {t('screens.packing.channelBox', { channel: label })}
        </Typography>
      </Box>
    </Box>
  );
};

export default PackingChannelBanner;
